/* ============================================================================
   SUNNY STRIPES — INSTANT QUOTE PRICING OVERRIDE          rewired 2026-08-31
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES IN THIS FILE. Every number comes from assets/ss-rates.js
   (window.SS_RATES), the one rate card the whole site reads. This file only
   translates between that rate card and the instant-quote tool's own vocabulary.

   Loaded by snippets/instant-quote-pricing.liquid, after ss-rates.js and after
   sunny-quote-v19.js. v19 is minified and not safely hand-editable, so instead
   of editing it we replace, in memory:

     CONFIG.pricing.mow      the mowing curve
     CONFIG.lots[].acres     the size cards, so "Large" is the same lawn here
                             as it is on /pages/topdressing
     window.svcPrice         v19's per-service price helper
     window.priceOf          v19's per-service price + caption helper
     window.computeTotals    wrapped, to relabel the topdressing row and apply
                             the topdressing+aeration bundle
     window.buildPayload     wrapped, to name the snow driveway, the
                             topdressing service and irrigation in the lead
     SVCS / CONSULTS         the service list itself

   KEY TRANSLATION — this tool's keys are not the rate card's keys:
     "aer" + mode "both"   -> aerseed        "clean" + which -> cleanupSpring
     "aer" + mode "aerate" -> aerate                         and/or cleanupFall
     "aer" + mode "seed"   -> overseed       "mulch"         -> topdress (!)
     "snow" + drive        -> snowSeason(driveKey)
     everything else maps to the same-named service.

   ----------------------------------------------------------------------------
   WHY TOPDRESSING LIVES IN THE "mulch" SLOT - READ THIS BEFORE EDITING

   Carl asked for compost topdressing to be sellable from the instant quote.
   Adding a genuinely new service key does not work: v19's computeTotals()
   iterates a hard-coded list of keys (fert, grub, aer, dethatch, clean, shrub,
   snow, mulch) and it is minified, so a new key renders a tile that prices at
   zero and never reaches the total. That was tried first and is exactly what
   it did.

   "mulch" is already in that list, and it was already dead: mulch and rock are
   quote-only (the material is the price), so this file used to delete the tile
   and force the flag off. So the slot is reused - a live, already-totalled
   service key with nothing in it. The tile is titled Compost Topdressing, and
   priceOf("mulch") returns the topdress rate.

   THE CONSEQUENCE, AND THE FIX: v19 hard-codes the estimate row's label as
   "Mulch / Rock" inside computeTotals, so the wrapper below rewrites that row
   after the fact. Mulch and rock themselves are untouched - they remain a
   free-consult chip, keyed "mulchrock", which is a different key entirely.

   If v19 is ever replaced with something editable, give topdressing its own key
   and delete this whole arrangement.

   ----------------------------------------------------------------------------
   SNOW IS PRICED BY DRIVEWAY HERE, NOT BY LAWN SIZE. It used to quote off lawn
   square footage, which put $475 on this page while /pages/snow-ice quoted the
   same 2-car driveway $580. Lawn area is a bad proxy for driveway area.

   EVERY PRICE ON THIS PAGE ROUNDS TO $5, MOWING INCLUDED
     Mowing used to be the one exception - shown raw off the curve. That stopped
     being defensible the moment a first mow became purchasable: the curve put
     $103 on the tile while the Shopify product charged $105. Rounding here
     fixes both ends, and 28 x $105 also matches the full-season product.

   WHERE THE ROUNDING HAPPENS MATTERS, NOT JUST THAT IT HAPPENS
     See the fert branch. Rounding a per-application price then multiplying is
     not the same as multiplying then rounding, and the Shopify product does the
     former. Backwards, it put $1,565 on screen against $1,560 at checkout.

   IF ss-rates.js IS MISSING this file refuses to apply and logs an error.
   ============================================================================ */
(function () {
  "use strict";

  var AER_KEY = { both: "aerseed", aerate: "aerate", seed: "overseed" };
  var AER_SUB = {
    both:   "aerate + overseed · one-time",
    aerate: "core aeration · one-time",
    seed:   "overseed · one-time"
  };

  var SNOW_DEFAULT_DRIVE = "d2";

  /* The row label v19 bakes into computeTotals for the reused slot. */
  var MULCH_ROW_LABEL = "Mulch / Rock";

  function apply() {
    var SS = window.SS_RATES;
    if (!SS) return false;
    if (typeof CONFIG === "undefined" || !CONFIG.pricing || typeof S === "undefined") return false;

    var r5 = SS.round5;
    var P = function (key, sqft) { return r5(SS.price(key, sqft)); };
    var sqftOf = function () { return (typeof svcAcres === "function" ? svcAcres() : 0) * 43560; };

    /* True when the customer has both topdressing and a full aerate+overseed,
       which is the pair /pages/topdressing discounts by bundleDiscount. */
    function bundled() {
      return !!(S.svc.mulch && S.svc.mulch.on &&
                S.svc.aer && S.svc.aer.on && (S.svc.aer.mode || "both") === "both");
    }
    /* Thousands separator, matching how v19 prints its own figures. */
    function commas(n) {
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    function bundleSaving(sf) {
      return r5((P("topdress", sf) + P("aerseed", sf)) * SS.bundleDiscount);
    }

    /* 1. Mowing curve and lot sizes, straight off the shared card ---------- */
    CONFIG.pricing.mow = SS.mow;
    var areaByKey = {};
    SS.tiers.forEach(function (t) { if (t.area != null) areaByKey[t.k] = t.area; });
    CONFIG.lots.forEach(function (lot) {
      if (areaByKey[lot.id] != null) lot.acres = areaByKey[lot.id] / 43560;
    });

    /* 2. Snow needs a driveway, not a lawn -------------------------------- */
    var SNOW_DRIVES = SS.snow.drives.filter(function (d) { return !d.custom; });
    if (S.svc.snow && S.svc.snow.drive == null) S.svc.snow.drive = SNOW_DEFAULT_DRIVE;
    var snowDrive = function () {
      return (S.svc.snow && S.svc.snow.drive) || SNOW_DEFAULT_DRIVE;
    };

    /* 2b. The every-other-week premium comes from the rate card ----------
       Two weeks of growth is a slower cut, so a biweekly visit costs more than
       a weekly one. v19 carried its own copy of that multiplier, and because
       the rate card did not know about it, the full-season BIWEEKLY products
       were built at the WEEKLY rate - 14 x $70 rather than 14 x $95 on a Large
       lawn. Nothing on the site contradicted itself, because only one side of
       the store knew the premium existed at all.

       Overriding mowPerVisit here makes MOW.biweeklyPremium the single home
       for it, so changing that number moves the page and the catalog together.
       This reproduces v19's current figures exactly - it is a change of
       ownership, not of price. Anything unexpected falls back to v19's own
       answer, so mowing can never end up unpriced. */
    if (typeof window.mowPerVisit === "function" && !window.mowPerVisit.__ssFreq) {
      var origMPV = window.mowPerVisit;
      var wrappedMPV = function () {
        try {
          if (typeof acresOf === "function") {
            var base = SS.mowPerVisit(acresOf());
            if (isFinite(base) && base > 0) {
              return (S.svc.mow && S.svc.mow.freq === "biweekly")
                ? base * SS.mow.biweeklyPremium
                : base;
            }
          }
        } catch (e) {}
        return origMPV.apply(this, arguments);
      };
      wrappedMPV.__ssFreq = true;
      window.mowPerVisit = wrappedMPV;
    }

    /* 3. Pricing functions ------------------------------------------------ */
    window.svcPrice = function (cfg) {
      if (cfg && cfg.ssKey) return P(cfg.ssKey, sqftOf()) || 0;
      return 0;
    };

    window.priceOf = function (k) {
      if (!S.lot) return null;
      if (typeof isCustom === "function" && isCustom()) return { custom: true };
      var sf = sqftOf();

      /* Mowing rounds to $5 like everything else - see the header note. */
      if (k === "mow") {
        return {
          main: r5(mowPerVisit()),
          sub: S.svc.mow.freq === "biweekly" ? "per visit · every 2 wks" : "per visit"
        };
      }
      /* Fertilization is per application, and so is the Shopify product: round
         the unit, then multiply. See the header note. */
      if (k === "fert") {
        return { main: P("fert", sf) * S.svc.fert.steps, sub: S.svc.fert.steps + "-step total" };
      }
      if (k === "grub") return { main: P("grub", sf), sub: "season add-on" };
      if (k === "aer") {
        var m = S.svc.aer.mode || "both";
        return { main: P(AER_KEY[m] || "aerseed", sf), sub: AER_SUB[m] || AER_SUB.both };
      }
      if (k === "dethatch") return { main: P("dethatch", sf), sub: "one-time" };
      if (k === "clean") {
        var w = S.svc.clean.which;
        var t = (w === "spring" || w === "both" ? P("cleanupSpring", sf) : 0)
              + (w === "fall"   || w === "both" ? P("cleanupFall", sf)   : 0);
        return { main: t, sub: w === "both" ? "spring + fall" : "per cleanup" };
      }
      if (k === "shrub") return { main: P("shrub", sf), sub: "confirmed on site" };
      if (k === "snow") {
        return {
          main: SS.snowSeason(snowDrive(), false) || 0,
          sub: "all winter · driveway only"
        };
      }
      /* THE REUSED SLOT. "mulch" is compost topdressing here - see the header. */
      if (k === "mulch") {
        return { main: P("topdress", sf), sub: "one-time" };
      }
      return null;
    };

    /* 4. Option chips on the service tiles -------------------------------- */
    if (S.svc.aer.mode == null) S.svc.aer.mode = "both";
    if (S.svc.aer.irr == null) S.svc.aer.irr = false;

    /* TEMPORARY IRRIGATION (added 2026-09-16) has no service key of its own,
       for the same reason topdressing borrows "mulch": v19's computeTotals only
       totals the keys it already knows. So it is an option chip on the aeration
       tile - offered only when the mode includes overseeding - and the totals
       wrapper below adds its row and its price. Never part of any discount. */
    function irrOn() {
      return !!(S.svc.aer && S.svc.aer.on && S.svc.aer.irr &&
                (S.svc.aer.mode || "both") !== "aerate");
    }
    function irrPrice(sf) {
      var v = SS.price("irrigation", sf);
      return v == null ? null : r5(v);
    }

    if (typeof SVCS !== "undefined") {
      for (var i = 0; i < SVCS.length; i++) {
        if (SVCS[i].k === "aer") {
          SVCS[i].opts = function () {
            return [
              { label: "Aerate + overseed", on: S.svc.aer.mode === "both",   set: function () { S.svc.aer.mode = "both"; } },
              { label: "Aeration only",     on: S.svc.aer.mode === "aerate", set: function () { S.svc.aer.mode = "aerate"; } },
              { label: "Overseed only",     on: S.svc.aer.mode === "seed",   set: function () { S.svc.aer.mode = "seed"; } }
            ].concat(S.svc.aer.mode === "aerate" ? [] : [{
              label: "+ Temporary irrigation" + (function () {
                var p = S.lot ? irrPrice(sqftOf()) : null;
                return p == null ? "" : " ($" + commas(p) + ")";
              })(),
              on: !!S.svc.aer.irr,
              set: function () { S.svc.aer.irr = !S.svc.aer.irr; }
            }]);
          };
        }
        if (SVCS[i].k === "snow") {
          SVCS[i].d = "Seasonal driveway clearing, automatic at " + SS.snow.trigger +
                      '" of snow — no call needed. Pick your driveway. Walks, salt and ' +
                      "per-visit pricing are on the Snow & Ice page.";
          SVCS[i].opts = function () {
            return SNOW_DRIVES.map(function (d) {
              return {
                label: d.nm,
                on: snowDrive() === d.k,
                set: function () { S.svc.snow.drive = d.k; }
              };
            });
          };
        }
      }
    }

    /* 5. The topdressing tile, in the reused "mulch" slot ------------------ */
    if (typeof SVCS !== "undefined") {
      var slot = null;
      for (var j = 0; j < SVCS.length; j++) if (SVCS[j].k === "mulch") slot = SVCS[j];
      if (!slot) {
        slot = { k: "mulch" };
        /* sits next to the other one-time renovation work */
        var after = SVCS.findIndex ? SVCS.findIndex(function (s) { return s.k === "dethatch"; }) : -1;
        if (after > -1) SVCS.splice(after + 1, 0, slot); else SVCS.push(slot);
      }
      slot.t = "Compost Topdressing";
      slot.d = "A quarter inch of screened compost across the whole lawn — levels the " +
               "surface and feeds the soil. Add core aeration + overseeding and " +
               "the pair is " +
               Math.round(SS.bundleDiscount * 100) + "% off.";
      slot.opts = null;
    }

    /* Mulch & decorative rock stay quote-only, as a free-consult chip. This is
       a DIFFERENT key from the "mulch" service slot above. */
    if (typeof CONSULTS !== "undefined") {
      var haveMulch = false;
      for (var c = 0; c < CONSULTS.length; c++) {
        if (CONSULTS[c].k === "mulchrock") haveMulch = true;
      }
      if (!haveMulch) {
        CONSULTS.push({ k: "mulchrock", t: "Mulch & Decorative Rock" });
        if (S.consult && S.consult.mulchrock == null) S.consult.mulchrock = false;
      }
    }

    /* 6. Relabel the topdressing row, and apply the pair discount ---------- */
    /* v19 bakes "Mulch / Rock" into computeTotals, and knows nothing about the
       topdressing+aeration bundle that /pages/topdressing has always offered.
       Both are fixed here rather than by editing v19, which cannot be edited.

       The discount is added to `bundle` and taken off `grand` only - NOT off
       `once`. That matches how v19 reports its own mow+fert bundle: the
       subtotal line shows the pre-discount figure and the saving is its own
       row. Taking it off `once` too showed the discount twice. */
    if (typeof window.computeTotals === "function" && !window.computeTotals.__ssTopdressWrapped) {
      var origCT = window.computeTotals;
      var wrappedCT = function () {
        var t = origCT.apply(this, arguments);
        try {
          var row = null, items = (t && t.items) || [];

          /* MOWING - THE RAIL AND THE TILE HAVE TO AGREE.
             v19 works its mowing figures straight off the raw curve, while
             priceOf() rounds to $5 and only the TILE goes through priceOf. On
             a Large lot that showed $70 on the tile and $72/visit in the rail
             beside it, with the month and the season built on the $72. The
             cart charges the rounded price, so the rounded price is the true
             one, and everything mowing-derived is re-based on it here.

             The visit counts are NOT copied. v19 owns how many mows a month
             and a season hold; they are recovered by dividing its own figures
             by the raw price, so if those constants ever change this still
             follows them. */
          if (S.svc.mow && S.svc.mow.on && S.lot && typeof mowPerVisit === "function") {
            var rawMow = mowPerVisit(), mow5 = r5(rawMow), mowRow = null;
            if (rawMow > 0) {
              for (var i1 = 0; i1 < items.length; i1++) {
                if (items[i1] && items[i1].nm === "Mowing") { mowRow = items[i1]; break; }
              }
              var oldSeason = t.seasonMow || 0;
              var visits = oldSeason ? Math.round(oldSeason / rawMow) : 0;
              var perMonth = t.monthlyMow ? t.monthlyMow / rawMow : 0;
              if (visits) {
                t.seasonMow = visits * mow5;
                t.grand = (t.grand || 0) + (t.seasonMow - oldSeason);
              }
              if (perMonth) t.monthlyMow = Math.round(mow5 * perMonth);
              if (mowRow) {
                mowRow.sub = String(mowRow.sub).replace(/\$[\d,]+(?=\/visit)/, "$" + mow5);
                mowRow.amt = String(mowRow.amt).replace(/\$[\d,]+/, "$" + commas(t.monthlyMow));
              }
            }
          }
          for (var i2 = 0; i2 < items.length; i2++) {
            if (items[i2] && items[i2].nm === MULCH_ROW_LABEL) { row = items[i2]; break; }
          }
          /* Temporary irrigation - its own row, straight onto the one-time
             subtotal and the grand total. Past an acre it is quoted on site. */
          if (irrOn() && S.lot) {
            var irr = irrPrice(sqftOf()), aerRow = null, irrRow;
            for (var i4 = 0; i4 < items.length; i4++) {
              if (items[i4] && /aerat|overseed/i.test(String(items[i4].nm))) { aerRow = items[i4]; break; }
            }
            irrRow = {};
            if (aerRow) for (var kk in aerRow) if (Object.prototype.hasOwnProperty.call(aerRow, kk)) irrRow[kk] = aerRow[kk];
            irrRow.nm = "Temporary Irrigation";
            if (irr == null) {
              irrRow.sub = "priced on site at this size";
              irrRow.amt = "Quote";
            } else {
              irrRow.sub = "about 4 weeks · set up and removed";
              irrRow.amt = "$" + commas(irr);
              if (typeof t.once === "number") t.once += irr;
              t.grand = (t.grand || 0) + irr;
            }
            var at = aerRow ? items.indexOf(aerRow) + 1 : items.length;
            items.splice(at, 0, irrRow);
          }
          if (row) {
            row.nm = "Compost Topdressing";
            row.sub = "one-time";
            if (bundled()) {
              var save = bundleSaving(sqftOf());
              t.bundle = (t.bundle || 0) + save;
              t.grand = (t.grand || 0) - save;
              row.sub = "one-time · bundled with core aeration + overseeding";
            }
          }
        } catch (e) {}
        return t;
      };
      wrappedCT.__ssTopdressWrapped = true;
      window.computeTotals = wrappedCT;
    }

    /* 7. Name the snow driveway and the topdressing service in the lead ---- */
    if (typeof window.buildPayload === "function" && !window.buildPayload.__ssSnowWrapped) {
      var origBuildPayload = window.buildPayload;
      var wrapped = function () {
        var p = origBuildPayload.apply(this, arguments);
        try {
          if (p && S.svc.snow && S.svc.snow.on) {
            var d = SS.snowDrive(snowDrive());
            p.snow_driveway = d.nm + " (" + d.sz + ")";
            p.snow_plan = "seasonal, driveway only";
          }
          /* The lead must not say "Mulch / Rock" for a topdressing job. */
          if (p && p.services && p.services.length) {
            for (var i3 = 0; i3 < p.services.length; i3++) {
              if (p.services[i3] === "Snow & Ice" && S.svc.snow && S.svc.snow.on) {
                p.services[i3] = "Snow & Ice (" + SS.snowDrive(snowDrive()).nm + ", seasonal)";
              }
              if (/mulch|rock/i.test(p.services[i3]) && S.svc.mulch && S.svc.mulch.on) {
                p.services[i3] = bundled()
                  ? "Compost Topdressing (bundled with core aeration + overseeding)"
                  : "Compost Topdressing";
              }
            }
          }
          if (p && S.svc.mulch && S.svc.mulch.on) {
            p.topdressing = true;
            p.topdressing_bundled = bundled();
          }
          if (p && irrOn()) {
            var ip = irrPrice(sqftOf());
            p.irrigation = true;
            p.quoted_irrigation = ip;
            if (p.services && p.services.push) {
              p.services.push(ip == null ? "Temporary Irrigation (quote on site)"
                                         : "Temporary Irrigation ($" + commas(ip) + ")");
            }
          }
        } catch (e) {}
        return p;
      };
      wrapped.__ssSnowWrapped = true;
      window.buildPayload = wrapped;
    }

    /* 8. Redraw with the shared numbers ----------------------------------- */
    try { if (typeof renderSvcs === "function") renderSvcs(); } catch (e) {}
    try { if (typeof calc === "function") calc(); } catch (e) {}
    return true;
  }

  if (!apply()) {
    var tries = 0;
    var t = setInterval(function () {
      if (apply()) { clearInterval(t); return; }
      if (++tries > 80) {
        clearInterval(t);
        console.error(
          "Sunny Stripes: the instant quote could not load its rate card. " +
          (window.SS_RATES ? "ss-rates.js loaded but sunny-quote-v19.js did not."
                           : "assets/ss-rates.js did not load.") +
          " The prices showing on this page are the tool's old built-in ones and are WRONG."
        );
      }
    }, 50);
  }
})();
